import { apiConstants } from '../_constants';
import { authHeader } from '../_helpers';
export const seriesTestService = {
    seriesTestAdd,
    seriesTestList,
    seriesTestDelete,
};
function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        console.log(text);
        if (data.error_code !== 0) {
            if (response.status === 401) {
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.message;
            return Promise.reject(error);
        }
        return data;
    });
}
function logout() {
    localStorage.removeItem('user');
}

//adding mockest
function seriesTestAdd(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/addseriestest', requestOptions).then(handleResponse);
}
//getting mocktestlist
function seriesTestList(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/getseriestestlist', requestOptions).then(handleResponse);
}

//delete mocktest
function seriesTestDelete(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/deleteseries', requestOptions).then(handleResponse);
}
